<div page-content [fullWidth]="true">
  <div actions class="uk-section-primary uk-preserve-color">
    <sidebar-mobile-toggle class="uk-hidden@m uk-display-block uk-padding-small"></sidebar-mobile-toggle>
  </div>
  <div inner>
    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent>
      <div class="uk-container">
        <div class="uk-flex uk-flex-between uk-flex-middle uk-visible@m">
          <!--          <h4>FAIR Data</h4>-->
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
              class="flag-image" width="42" height="42" alt="rounded flag image">
            <div class="uk-margin-small-left">
              <h4 class="uk-margin-remove-bottom">{{ countryName }} - FAIR Data for {{ year }}</h4>
            </div>
          </div>
          <div class="uk-flex uk-flex-center"
            (click)="exportToPDF([exportContent, exportContent1, exportContent2, exportContent3, exportContent4, exportContent5], 'Open Data')"
            style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary" style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class="" style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>

        <div class="uk-hidden@m">
          <!--          <h4>Open Data</h4>-->
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
              class="flag-image" width="42" height="42" alt="rounded flag image">
            <div class="uk-margin-small-left">
              <h4 class="uk-margin-remove-bottom">{{ countryName }} - FAIR Data for {{ year }}</h4>
            </div>
          </div>
          <div (click)="exportToPDF([exportContent, exportContent1, exportContent2, exportContent3, exportContent4, exportContent5], 'Open Data')"
            class="uk-flex uk-flex-right" style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary" style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left" data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="section-hidden-notice-band">
      <div class="uk-container">
        <app-section-hidden-notice sectionName="FAIR Data"></app-section-hidden-notice>
      </div>
    </div>

    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent1>
      <div class="uk-container">

        <p class="uk-text-lead">FAIR Data principles refer to guidelines that ensure data are Findable, Accessible,
          Interoperable, and Reusable. These principles aim to enhance the utility and availability of data generated by
          scientific research, promoting more efficient discovery and analysis by both humans and machines. The FAIR
          principles advocate for robust metadata and data standards, easy discoverability through persistent
          identifiers, accessible data under well-defined conditions, interoperable formats that allow integration with
        other datasets, and clear usage licenses to maximize data reuse.</p>

      </div>
    </div>

    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent2>
      <div class="uk-container">

        <h5>Monitoring FAIR data and its challenges</h5>

        <p>Monitoring FAIR data is a complex task due to the evolving nature of definitions surrounding which datasets
          qualify as FAIR and which do not. As the criteria for assessing data against these principles are still being
          refined, we currently offer only a limited number of analyses on FAIR data. This limitation reflects the
          ongoing development in the understanding and implementation of the FAIR principles within the scientific and
          data management communities. As methodologies mature and definitions become more standardized, we anticipate
        expanding our analytical offerings to provide more comprehensive insights into FAIR data practices.</p>

      </div>
    </div>

    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent3>
      <div class="uk-container">

        <div class="uk-flex uk-flex-between uk-flex-middle">
          <h5>General Overview of Open Data in {{countryName}} for {{ year }}</h5>
        </div>

        <div class="uk-grid-small" data-uk-grid>
          @if (hasAnyLeftCardVisible()) {
            <div class="uk-width-1-1 uk-width-3-5@m uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body">
                <div
                  class="uk-child-width-1-1@s uk-child-width-1-2@m uk-grid-small uk-grid-match uk-flex uk-flex-center"
                  data-uk-grid
                  data-uk-height-match="target: > * .uk-card">
                  <app-card-config indicatorId="33" colorClass="eosc-sb visualisation-card">
                  @if (rfoFairDataPercentage[1] !== null) {
                    <app-info-card
                      [titleHtml]="`Percentage of <span class='uk-text-bold'>RFO's Policy on FAIR Data</span>`"
                      [value]="rfoFairDataPercentage[1]"
                      [unit]="'%'"
                      [diff]="rfoFairDataPercentageDiff"
                      colorClass="eosc-sb visualisation-card">
                    </app-info-card>
                  }
                  </app-card-config>
                  <app-card-config indicatorId="34" colorClass="eosc-sb visualisation-card">
                  @if (rpoFairDataPercentage[1] !== null) {
                    <app-info-card
                      [titleHtml]="`Percentage of <span class='uk-text-bold'>RPO's Policy on FAIR Data</span>`"
                      [value]="rpoFairDataPercentage[1]"
                      [unit]="'%'"
                      [diff]="rpoFairDataPercentageDiff"
                      colorClass="eosc-sb visualisation-card">
                    </app-info-card>
                  }
                  </app-card-config>
                  <app-card-config indicatorId="35" colorClass="eosc-sb visualisation-card">
                  @if (financialInvestmentInFairData[1] !== null) {
                    <app-info-card
                      [titleHtml]="`Total <span class='uk-text-bold'>financial investment in FAIR Data</span>`"
                      [value]="financialInvestmentInFairData[1]"
                      [unit]="'mil Euro'"
                      [diff]="financialInvestmentInFairDataPercentageDiff"
                      colorClass="eosc-sb visualisation-card">
                    </app-info-card>
                  }
                  </app-card-config>
                </div>
              </div>
            </div>
          }

          <!-- Right Card (2/5) -->
          <app-card-config indicatorId="36" class="uk-width-1-1 uk-width-2-5@m uk-animation-fade">
          <div>
            <div class="uk-card uk-card-default uk-card-body eosc-sb visualisation-card">
              <div class="uk-margin-top">
                <h5 class="uk-flex uk-flex-between uk-margin-remove">
                  National Policy on FAIR Data
                  <span class="material-symbols-outlined" [ngClass]="{
                      'up-arrow-color': hasNationalPolicyFD === 'Yes',
                      'down-arrow-color': hasNationalPolicyFD === 'No',
                      'unanswered-color': hasNationalPolicyFD === null || hasNationalPolicyFD === undefined
                    }">
                    {{
                    hasNationalPolicyFD === 'Yes' ? 'check' :
                    hasNationalPolicyFD === 'No' ? 'close' :
                    'question_mark'
                    }}
                  </span>
                </h5>
                @if (policyMandatoryFD === 'Yes') {
                  <p class="uk-text-primary uk-text-bolder uk-margin-remove-top">
                  Mandatory policy</p>
                }
                @if (nationalPolicyClarificationFD === 'Yes') {
                  <read-more-text [maxHeight]="68"
                  [text]="nationalPolicyClarificationFD"></read-more-text>
                }
              </div>
              <div class="uk-margin-top">
                <h5 class="uk-flex uk-flex-between">
                  Financial Strategy on FAIR Data
                  <span class="material-symbols-outlined" [ngClass]="{
                      'up-arrow-color': hasFinancialStrategyFD === 'Yes',
                      'down-arrow-color': hasFinancialStrategyFD === 'No',
                      'unanswered-color': hasFinancialStrategyFD === null || hasFinancialStrategyFD === undefined
                    }">
                    {{
                    hasFinancialStrategyFD === 'Yes' ? 'check' :
                    hasFinancialStrategyFD === 'No' ? 'close' :
                    'question_mark'
                    }}
                  </span>
                </h5>
                @if (financialStrategyClarificationFD) {
                  <read-more-text [maxHeight]="68"
                  [text]="financialStrategyClarificationFD"></read-more-text>
                }
              </div>
              <div class="uk-margin-top">
                <h5 class="uk-flex uk-flex-between">
                  Monitoring on FAIR Data
                  <span class="material-symbols-outlined" [ngClass]="{
                      'up-arrow-color': hasMonitoringFD === 'Yes',
                      'down-arrow-color': hasMonitoringFD === 'No',
                      'unanswered-color': hasMonitoringFD === null || hasMonitoringFD === undefined
                    }">
                    {{
                    hasMonitoringFD === 'Yes' ? 'check' :
                    hasMonitoringFD === 'No' ? 'close' :
                    'question_mark'
                    }}
                  </span>
                </h5>
                @if (monitoringClarificationFD) {
                  <read-more-text [maxHeight]="68"
                  [text]="monitoringClarificationFD"></read-more-text>
                }
              </div>
            </div>
          </div>
          </app-card-config>

          <div>
            <p><span class="uk-text-bold">Data source:</span>
            Survey on National Contributions to EOSC and Open Science {{year}} -
            showing data for {{ year }}, except financial contributions, which reflect the previous year ({{+year-1}});
            OpenAIRE Graph data for {{ year }} (updated on {{ lastUpdateDate }}).
          </p>
        </div>

      </div>
    </div>
  </div>

  <div #exportContent4>
    @if (hasCountrySurveyAnswerData()) {
      <div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
        <div class="uk-container">
          <app-card-config indicatorId="37">
          <div class="uk-animation-fade">
            <div class="uk-card uk-card-body uk-card-default uk-width-1-1 noads visualisation-card">
              <h6 class="uk-margin-bottom">Learn more about FAIR Data Landscape in {{ countryName }}</h6>
              <div class="uk-text-meta">This information has been compiled by the National Open Access Desks on {{ countrySurveyAnswerLastUpdate | date: 'yyyy-MM-dd'}}</div>
              <div class="uk-margin-medium-top">
                <read-more [maxHeight]="300">
                  <div id="fair_national_data_service">
                    <div class="uk-text-secondary uk-margin-small-bottom">National Data Service</div>
                    @if (countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question15']?.['Question15-1']) {
                      <div class="uk-margin-remove-top"
                           [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question15']['Question15-1']">
                      </div>
                    } @else {
                      <p class="uk-margin-remove-top">N/A</p>
                    }
                  </div>
                  <div id="fair_data_repositories" class="uk-margin-medium-top">
                    <div class="uk-text-secondary uk-margin-small-bottom">Data repositories</div>
                    @if (countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question18']?.['Question18-1']) {
                      <div class="uk-margin-remove-top"
                           [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question18']['Question18-1']">
                      </div>
                    } @else {
                      <p class="uk-margin-remove-top">N/A</p>
                    }
                  </div>
                </read-more>
              </div>
            </div>
          </div>
          </app-card-config>
        </div>
      </div>
    }
  </div>

  <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent5>
    <div class="uk-container">
      <div class="uk-child-width-1-1 uk-child-width-1-2@m" data-uk-grid>
        <app-card-config indicatorId="38">
        @if (stackedColumnSeries1[0].data.length) {
          <div>
            <div class="uk-card uk-card-default eosc-sb visualisation-card uk-card-body">
              <app-stacked-column [categories]="stackedColumnCategories" [series]="stackedColumnSeries1"
                [yAxis]="yAxisTitle"
                [title]="'Trend of Policies on FAIR Data among Research Performing Organisations in '+ countryName"
                [stacking]="'percent'" [plotFormat]="plotFormat" [pointFormat]="tooltipPointFormat"
                [stackLabels]="false" [yAxisLabelsFormat]="labelFormat" [xAxis]="xAxisTitle" [height]="700"
                [caption]="'<p class=\'uk-text-justify\'>The presented graph shows the adoption of FAIR Data policies among Research Performing Organisations (RPOs). It highlights the percentage of RPOs that have implemented policies supporting FAIR data principles, compared to those without such policies.</p>' +
                                  '<p><strong>Data Source: </strong> Survey on National Contributions to EOSC and Open Science for year '+year+'.</p>'">
              </app-stacked-column>
            </div>
          </div>
}
        </app-card-config>
          <app-card-config indicatorId="39">
          @if (stackedColumnSeries2[0].data.length) {
<div>
            <div class="uk-card uk-card-default eosc-sb visualisation-card uk-card-body">
              <app-stacked-column [categories]="stackedColumnCategories" [series]="stackedColumnSeries2"
                [yAxis]="yAxisTitle"
                [title]="'Trend of Policies on FAIR Data among Research Funding Organisations in '+ countryName"
                [stacking]="'percent'" [plotFormat]="plotFormat" [pointFormat]="tooltipPointFormat"
                [stackLabels]="false" [yAxisLabelsFormat]="labelFormat" [xAxis]="xAxisTitle" [height]="700"
                [caption]="'<p class=\'uk-text-justify\'>The presented graph shows on Research Funding Organisations (RFOs) and their commitment to FAIR Data policies. It illustrates the percentage of RFOs that have implemented FAIR data policies, alongside those that have not.</p>' +
                                  '<p><strong>Data Source: </strong> Survey on National Contributions to EOSC and Open Science for year '+year+'.</p>'">
              </app-stacked-column>
            </div>
          </div>
}
        </app-card-config>
        </div>
      </div>
    </div>
  </div>
</div>
